import { ClipboardCopyIcon } from "@heroicons/react/outline";
import ReactTooltip from "react-tooltip";

const CopyBlockButton = ({ block_id }: { block_id: number }) => {
  return (
    <>
      <ReactTooltip
        id={`copy-block-clipboard-${block_id}`}
        place="top"
        backgroundColor="var(--grey)"
        effect="solid"
        delayHide={250}
        afterShow={() => {
          navigator.clipboard
            .writeText(`block-${block_id}`)
            .then(() => console.log(`Copied block-${block_id}`))
            .catch(() => {
              console.error(`Error copying block-${block_id}`);
            });
        }}
      />
      <button
        data-for={`copy-block-clipboard-${block_id}`}
        data-event="click"
        data-event-off="mouseout"
        data-tip={`Copied block-${block_id}`}
        className="PWTable__actions__button pwButton--grey"
        title={`Copy block-${block_id}`}
      >
        <ClipboardCopyIcon height={20} />
      </button>
    </>
  );
};

export default CopyBlockButton;
